import { Button } from '@attive/ui/button'
import {
	DropdownMenu,
	DropdownMenuContent,
	DropdownMenuItem,
	DropdownMenuPortal,
	DropdownMenuTrigger,
} from '@attive/ui/dropdown-menu'
import { Lock, LogOut, User } from '@attive/ui/icons'
import { useRef } from 'react'
import { Form, Link, useSubmit } from 'react-router'
import { useUser } from '#app/utils/user'
import { UserAvatar } from './UserAvatar'

interface UserMenuProps {
	collapsed?: boolean
}

export function UserMenu({ collapsed = false }: UserMenuProps) {
	const user = useUser()
	const submit = useSubmit()
	const formRef = useRef<HTMLFormElement>(null)

	return (
		<DropdownMenu>
			<DropdownMenuTrigger asChild>
				<Button
					asChild
					variant="ghost"
					className={collapsed ? 'h-8 w-8 p-0' : 'h-8 px-2 py-1'}
				>
					<Link
						to="/settings/profile"
						// this is for progressive enhancement
						onClick={(e) => e.preventDefault()}
						className="flex items-center gap-1.5"
					>
						<UserAvatar user={user} size="sm" className="h-6 w-6" />

						{!collapsed && (
							<span className="text-sm font-medium">{user.name}</span>
						)}
					</Link>
				</Button>
			</DropdownMenuTrigger>
			<DropdownMenuPortal>
				<DropdownMenuContent sideOffset={8} align="start">
					<DropdownMenuItem asChild>
						<Link prefetch="intent" to="/settings/profile">
							<User className="mr-2 h-4 w-4" />
							Profile
						</Link>
					</DropdownMenuItem>
					{user.isAdmin && (
						<DropdownMenuItem asChild>
							<Link prefetch="intent" to="/admin">
								<Lock className="mr-2 h-4 w-4" />
								Admin
							</Link>
						</DropdownMenuItem>
					)}
					<DropdownMenuItem
						asChild
						// this prevents the menu from closing before the form submission is completed
						onSelect={(event) => {
							event.preventDefault()
							void submit(formRef.current)
						}}
					>
						<Form action="/logout" method="POST" ref={formRef}>
							<LogOut className="mr-2 h-4 w-4" />
							Logout
						</Form>
					</DropdownMenuItem>
				</DropdownMenuContent>
			</DropdownMenuPortal>
		</DropdownMenu>
	)
}
